export default "__VITE_ASSET__7tJN_o0w__"